var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClassRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_class_rule",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24822",
    "data-name": "\\uC0AC\\uAC01\\uD615 24822",
    width: 24,
    height: 24,
    fill: "#f1f1f1",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10732",
    "data-name": "\\uD328\\uC2A4 10732",
    d: "M505.462,359.929l-2.414-4.225v-2.042a.464.464,0,0,0-.464-.464h-3.4v-.7h1.856a.464.464,0,0,0,.464-.464V347.4a.464.464,0,0,0-.464-.463H496.4a.464.464,0,0,0-.464.463v4.641a.464.464,0,0,0,.464.464h1.856v.7h-3.4a.464.464,0,0,0-.464.464v1.749a2.785,2.785,0,1,0,.928,0v-1.286h6.807V355.7l-2.488,4.223a.464.464,0,0,0,.4.7h5.028a.464.464,0,0,0,.4-.695Zm-8.6-12.069h3.713v3.714H496.86Zm-.155,10.289a1.856,1.856,0,1,1-1.856-1.857A1.859,1.859,0,0,1,496.705,358.148Zm4.138,1.548,1.734-2.944,1.682,2.944Z",
    transform: "translate(-486.794 -341.932)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClassRule);
export default __webpack_public_path__ + "static/media/icon_class_rule.94c2f6018939a7f28abce929d29c9563.svg";
export { ForwardRef as ReactComponent };